<template>
  <icon-card
    class="exam-tip"
  >
    <template v-slot:icon>
      <div class="circle">
        <div>
          <icon
            name="lightbulb"
          ></icon>
        </div>
      </div>
    </template>
    <template v-slot:title>
      Exam Tip
    </template>
    <p>
      <slot></slot>
    </p>
  </icon-card>
</template>

<script>
import Icon from '@/components/singletons/icon';
import IconCard from './IconCard.vue';

export default {
  components: {
    Icon,
    IconCard,
  },
};
</script>

<style lang="scss" scoped>
.exam-tip {
  border: 1px solid #D0D5DD;
  background-color: #F2F4F7;
  border-radius: rem-calc(16);
}

.circle {
  display: grid;
  width: rem-calc(24);
  height: rem-calc(24);
  border-radius: 50%;
  background-color: #D1E0FF;
  justify-content: center;
}
</style>
